import { render } from "./HomeView.vue?vue&type=template&id=a78e5a8c"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__